/* ═══ ESPIAR (quick view) — item 2 do backlog [2026-08-21] ═══════════════════
   Abre a peça sobre a grade, sem sair da página. O conteúdo vem do template
   `templates/product.quickview.liquid` — ou seja, do MESMO Liquid que a página
   de produto usa para preço, Pix e disponibilidade. Nada é recalculado aqui.

   🪤 O BOTÃO "ADICIONAR" NÃO PRECISA DE CÓDIGO NESTE ARQUIVO. Ele sai do
     template já como `.pc-add[data-variante]`, e o ettore-gaveta.js escuta
     esse gancho NO DOCUMENTO — inclusive para HTML que nasceu depois, como
     este. Foi por isso que escolhi essa classe em vez de inventar outra.
*/
(function () {
  'use strict';

  /* guarda global: o snippet do cartão aparece em várias seções, e o script é
     carregado uma vez pelo cabeçalho — mas se um dia ele for incluído duas
     vezes, dois ouvintes abririam dois modais no mesmo clique */
  if (window.__ettoreEspiar) return;
  window.__ettoreEspiar = 1;

  var modal = null;
  var corpo = null;
  var voltarPara = null;
  var cache = {};

  function monta() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'qv ettore';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="qv-veu" data-qv-fecha></div>' +
      '<div class="qv-cx" role="dialog" aria-modal="true" aria-label="Detalhes da peça" tabindex="-1">' +
        '<button type="button" class="qv-x" data-qv-fecha aria-label="Fechar">' +
          '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
          '<path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="qv-corpo" data-qv-corpo><p class="qv-carreg">Carregando…</p></div>' +
      '</div>';
    document.body.appendChild(modal);
    corpo = modal.querySelector('[data-qv-corpo]');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-fecha]')) { e.preventDefault(); fecha(); }
    });
  }

  function abre() {
    modal.hidden = false;
    /* dois quadros antes de animar, e o foco NO QUADRO SEGUINTE ao da classe.
       🪤 Não é preciosismo: o `.qv` fica `visibility:hidden` até ganhar
         `data-aberto`, e elemento invisível NÃO recebe foco — `.focus()` não
         lança erro, simplesmente não faz nada. Foi exatamente o defeito que
         medi no pop-up do questionário neste mesmo dia. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.setAttribute('data-aberto', '');
        requestAnimationFrame(function () { modal.querySelector('.qv-cx').focus(); });
      });
    });
    document.documentElement.style.overflow = 'hidden';
    /* 🔴 O DESFOQUE DO FUNDO É CLASSE NO <html>, NÃO `backdrop-filter` —
       [2026-08-21], segunda tentativa depois de ele dizer duas vezes que não
       embaçava. O véu tinha `backdrop-filter:blur(7px)` declarado e a
       propriedade estava LÁ no `getComputedStyle`, mas o fundo continuava
       nítido em toda captura que fiz, nos dois motores. Não consegui provar a
       causa (as capturas sem interface não desenham `backdrop-filter`, então a
       régua não serve para este caso), e insistir seria apostar.
       Aqui o desfoque vai no CONTEÚDO da página, com `filter` — que renderiza
       em qualquer lugar, aparece na captura e portanto EU CONSIGO VERIFICAR.
       O modal fica fora do alvo porque mora no `<body>`, irmão do `<main>`. */
    document.documentElement.classList.add('qv-aberto');
  }

  function fecha() {
    modal.removeAttribute('data-aberto');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('qv-aberto');
    setTimeout(function () { modal.hidden = true; }, 260);
    if (voltarPara) { voltarPara.focus(); voltarPara = null; }
  }

  function carrega(handle) {
    if (cache[handle]) { corpo.innerHTML = cache[handle]; liga(); return; }
    corpo.innerHTML = '<p class="qv-carreg">Carregando…</p>';
    fetch(window.Shopify.routes.root + 'products/' + handle + '?view=quickview')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { cache[handle] = html; corpo.innerHTML = html; liga(); })
      .catch(function () {
        /* ⚠️ A SAÍDA NUNCA É UM MODAL VAZIO. Se a busca falhar, o espiar deixa
           de ser um atalho e vira um beco: aqui ele oferece o caminho normal,
           que é a página da peça. */
        corpo.innerHTML = '<p class="qv-carreg">Não consegui carregar aqui. ' +
          '<a href="' + window.Shopify.routes.root + 'products/' + handle + '">Abrir a página da peça</a></p>';
      });
  }

  /* ── o que passa a funcionar depois que o HTML entra ──────────────────
     Duas coisas: as miniaturas trocam a foto grande, e as opções cruzam para
     achar a variante. Tudo relido a cada peça, porque o corpo é substituído
     inteiro — guardar referências na abertura apontaria para elementos mortos
     na peça seguinte. */
  function liga() {
    /* ── a galeria em slide ─────────────────────────────────────────────
       A faixa anda com `translateX`; as miniaturas e as setas só mudam o
       índice. Nada de biblioteca: são três linhas de conta. */
    var faixa = corpo.querySelector('[data-qv-faixa]');
    var minis = corpo.querySelectorAll('.qv-mini');
    var quadros = corpo.querySelectorAll('.qv-quadro');
    var atual = 0;

    function vaiPara(i) {
      if (!faixa || !quadros.length) return;
      /* dá a volta nas pontas: da última para a primeira e vice-versa —
         seta que não faz nada na ponta parece quebrada */
      atual = (i + quadros.length) % quadros.length;
      faixa.style.transform = 'translateX(' + (-atual * 100) + '%)';
      Array.prototype.forEach.call(minis, function (m, k) {
        m.classList.toggle('on', k === atual);
      });
    }

    Array.prototype.forEach.call(minis, function (m) {
      m.addEventListener('click', function () {
        vaiPara(parseInt(m.getAttribute('data-i'), 10) || 0);
      });
    });
    var ant = corpo.querySelector('[data-qv-ant]');
    var prox = corpo.querySelector('[data-qv-prox]');
    if (ant) ant.addEventListener('click', function () { vaiPara(atual - 1); });
    if (prox) prox.addEventListener('click', function () { vaiPara(atual + 1); });

    /* ── as opções → a variante ───────────────────────────────────────
       🔴 SAIU DAQUI EM [2026-08-21]. Esta função guardava a própria cópia do
         cruzamento escolha→variante, e a página de produto não tinha nenhuma —
         medido no mesmo dia: ela vendia sempre a primeira variante, com os
         pendentes cobrando por tamanho de fio (289/309/319). Duas telas, uma
         regra: o motor agora é o `ettore-opcoes.js`, e ele escreve nos ganchos
         `data-eop-*` que este template declara. */
    if (window.ettoreOpcoes) window.ettoreOpcoes.liga(corpo);
  }

  document.addEventListener('click', function (e) {
    var bt = e.target.closest && e.target.closest('[data-espiar]');
    if (!bt) return;
    e.preventDefault();
    e.stopPropagation();      /* o cartão inteiro é um link: sem isto, navega */
    monta();
    voltarPara = bt;
    abre();
    carrega(bt.getAttribute('data-espiar'));
  });

  document.addEventListener('keydown', function (e) {
    if (!modal || !modal.hasAttribute('data-aberto')) return;
    if (e.key === 'Escape') { fecha(); return; }
    if (e.key !== 'Tab') return;

    /* laço de foco, lido a cada tecla porque o corpo é trocado a cada peça */
    var caixa = modal.querySelector('.qv-cx');
    var focaveis = caixa.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var lista = Array.prototype.filter.call(focaveis, function (el) { return el.offsetParent !== null; });
    if (!lista.length) { e.preventDefault(); caixa.focus(); return; }
    var primeiro = lista[0], ultimo = lista[lista.length - 1], atual = document.activeElement;
    if (!caixa.contains(atual) || atual === caixa) {
      e.preventDefault(); (e.shiftKey ? ultimo : primeiro).focus(); return;
    }
    if (e.shiftKey && atual === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && atual === ultimo) { e.preventDefault(); primeiro.focus(); }
  });

  /* adicionou pelo espiar → a gaveta abre por cima. Fechar o modal evita duas
     camadas empilhadas sobre a mesma página. O evento é o mesmo que a nav e o
     cabeçalho já escutam; nada de canal novo. */
  document.addEventListener('cart:refresh', function () {
    if (modal && modal.hasAttribute('data-aberto')) fecha();
  });
})();
